import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {JobService} from "../../../../services/job.service";
import {Job} from "../../../../model/job.model";

@Component({
  selector: 'app-dialog-job',
  templateUrl: './dialog-job.component.html',
  styleUrls: ['./dialog-job.component.scss']
})
export class DialogJobComponent {

  profileForm;

  constructor(private service: JobService,
              private dialogRef: MatDialogRef<DialogJobComponent>,
              private fb:FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.profileForm = Job.formBuilder(this.fb, this.data.job);
  }

  onSubmit(){
    if (this.data.action == 'modify') {
      this.service.put(this.data.job._id, this.profileForm.value).subscribe((e) => {
        this.dialogRef.close(e);
      });
    }
    if (this.data.action == 'create') {
      this.service.post(this.profileForm.value).subscribe((e) => {
        this.dialogRef.close(e);
      });
    }
  }
}
